export default __webpack_public_path__ + "static/media/wave_3.5ceeb066.jpg";